// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"3a61127a96893fb0","702":"c2f19684f620347e"}[chunkId] + ".js";
};